import queryString from 'query-string'
import { GlobalShell } from 'components/GlobalShell'
import { alertTypes } from 'components/RouteQueryAlert'
import { useWorkspaceChange } from 'hooks/useWorkspaceChange'
import { useHistory, useLocation } from 'lib/router'
import AdminInviteConfirm from 'views/AdminInviteConfirm'

export const AdminInviteConfirmContainer = () => {
  const location = useLocation()
  const history = useHistory()
  const queryParams = queryString.stringify({
    ...queryString.parse(location.search),
    notice: alertTypes.adminInviteAccepted,
  })
  const onWorkspaceChange = useWorkspaceChange()

  return (
    <GlobalShell>
      <AdminInviteConfirm
        onWorkspaceChange={ids => {
          onWorkspaceChange(ids)
          history.push(`/?${queryParams}`)
        }}
      />
    </GlobalShell>
  )
}
